var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbcPartnership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.51 221.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0097db;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #0d2a50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 143.41,
    cy: 48.94,
    r: 48.94,
    transform: "translate(-.88 2.67) rotate(-1.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.51,88.53c-9.32,10.11-25.77,20.22-46.86,20.22-16.37,0-30.46-6.36-39.43-13.43C39.78,100.93.04,108.87.04,108.87v21.64l283.46-.03v-44.61s-48.57-.3-104,2.66Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.51,217.23c-7.95,2.43-18.39,3.86-27.74,3.86-33.31,0-57.77-9.47-57.77-37.01,0-24.89,23.71-35.7,56.11-35.7,9.01,0,20.45.99,29.4,3.85v24.11c-6.64-4.02-13.28-6.52-22.77-6.52-12.36,0-24.71,6.09-24.71,14.92s12.3,14.92,24.71,14.92c9.35,0,16.13-2.59,22.76-6.42v23.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.51,217.23c-7.95,2.43-18.39,3.86-27.74,3.86-33.31,0-57.77-9.47-57.77-37.01,0-24.89,23.71-35.7,56.11-35.7,9.01,0,20.45.99,29.4,3.85v24.11c-6.64-4.02-13.28-6.52-22.77-6.52-12.36,0-24.71,6.09-24.71,14.92s12.3,14.92,24.71,14.92c9.35,0,16.13-2.59,22.76-6.42v23.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.62,150h68.07c17.68,0,23.48,6.88,23.48,17.58,0,11.98-10.71,17.19-21.71,17.78v.2c11.29.88,22.3,2.16,22.3,16.3,0,9.23-5.8,18.27-25.24,18.27h-66.89v-70.13ZM133.29,205.87h17.56c6.58,0,8.82-2.72,8.82-6.75s-2.26-6.92-8.75-6.92h-17.63v13.67ZM133.29,179.72h16.77c6.48,0,9.02-2.63,9.02-6.65,0-4.62-2.56-6.92-8.55-6.92h-17.24v13.57Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbcPartnership);
export default __webpack_public_path__ + "static/media/cbc-partnership.c9a107381ce1fbc8fbf9483782a2aac0.svg";
export { ForwardRef as ReactComponent };